export const ROLE = {
  DEVELOP: -1,
  ADMIN: 'Admin',
  NORMAL: 'Normal',
  SERVICE: 'Service',
  SALES: 'Sales',
  ACCOUNT: 'Account',
}
